import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo/logo-questnova-prancheta-1.png")